import { render, staticRenderFns } from "./CTAs.vue?vue&type=template&id=47749401&"
import script from "./CTAs.vue?vue&type=script&lang=js&"
export * from "./CTAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CTAs.vue"
export default component.exports